import React, { useContext, useEffect } from "react";
import PagePreview from "./Preview";
import { useSelector } from "react-redux";
import PageContainer from "~/components/PageContainer";
import { FullGridContext } from "../..";
import api from "~/services/api";
import { toast } from "react-toastify";

export default function FinancialCashflowRegister() {
  const filial = useSelector((state) => state.auth.filial);
  const defaultOrderBy = { column: "cashflow_name", asc: true };
  const defaultGridHeader = [
    {
      title: "Cashflow Name",
      name: "cashflow_name",
      type: "text",
      filter: true,
    },
    {
      title: "Cashflow Code",
      name: "cashflow_code",
      type: "text",
      filter: false,
    },
    {
      title: "Status",
      name: "status",
      type: "text",
      filter: true,
    },
    {
      title: "Created At",
      name: "created_at",
      type: "date",
      filter: false,
    },
  ];

  const {
    accessModule,
    activeFilters,
    gridData,
    gridDetails,
    gridHeader,
    handleFilters,
    handleOpened,
    limit,
    loadingData,
    opened,
    orderBy,
    page,
    pages,
    search,
    setActiveFilters,
    setGridData,
    setGridDetails,
    setGridHeader,
    setLimit,
    setLoadingData,
    setOpened,
    setOrderBy,
    setPage,
    setPages,
    setSearch,
    setTotalRows,
    setSuccessfullyUpdated,
    successfullyUpdated,
    totalRows,
  } = useContext(FullGridContext);
  
  const pageAccess = { view: true, edit: true, create: true, inactivate: false };

  useEffect(() => {
    setActiveFilters([]);
  }, []);
  
  async function loader() {
    setLoadingData(true);
    
    try {
      const { data } = await api.get('/cashflowconfigs-getall');
      
      const gridDataValues = data.map(({ id, cashflow_name, cashflow_code, status, created_at }, index) => ({
        show: true,
        id,
        fields: [
          cashflow_name, 
          cashflow_code, 
          status,
          new Date(created_at).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: '2-digit', 
            day: '2-digit' 
          })
        ],
        page: Math.ceil((index + 1) / limit),
      }));
      
      setPages(Math.ceil(data.length / limit));
      setGridDetails({ totalRows: data.length, pages: Math.ceil(data.length / limit) });
      setGridData(gridDataValues);
    } catch (err) {
      console.error('Error loading Cashflow configs:', err);
      toast.error('Error loading Cashflow configurations');
    } finally {
      setLoadingData(false);
    }
  }

  useEffect(() => {
    loader();
  }, [opened, filial, orderBy, search, limit, page, successfullyUpdated]);

  return (
    <PageContainer
      FullGridContext={FullGridContext}
      PagePreview={PagePreview}
      pageAccess={pageAccess}
      defaultGridHeader={defaultGridHeader}
      newButtonNearSearch={true}
    />
  );
}